import { AuthProviderProps } from 'react-oidc-context';

import {
  parseStageFromUrl,
  Stage,
  STAGE_HOSTNAMES,
} from '../constants/serviceConstants';

interface AuthConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  logoutUri: string;
  cognitoDomain: string;
}

// The authority & client_id come from the console after the first deployment.
const STAGE_AUTH_CONFIG: Record<Stage, AuthConfig> = {
  [Stage.DEV]: {
    authority:
      'https://cognito-idp.eu-south-2.amazonaws.com/eu-south-2_5BEwBnRQb',
    client_id: '1pqdrq4uk9nj1m0lkafap9fjh',
    redirect_uri: `http://${STAGE_HOSTNAMES[Stage.DEV][0]}:8080`,
    response_type: 'code',
    scope: 'openid profile',
    logoutUri: 'http://localhost:8080/unauthorized-access',
    cognitoDomain: 'https://d99zdo8o8lxqb.auth.eu-south-2.amazoncognito.com',
  },
  [Stage.BETA]: {
    authority:
      'https://cognito-idp.eu-south-2.amazonaws.com/eu-south-2_5BEwBnRQb',
    client_id: '1pqdrq4uk9nj1m0lkafap9fjh',
    redirect_uri: `https://${STAGE_HOSTNAMES[Stage.BETA][0]}`,
    response_type: 'code',
    scope: 'openid profile',
    logoutUri: 'https://beta.adslots.in-adtech.amazon.dev/unauthorized-access',
    cognitoDomain: 'https://d99zdo8o8lxqb.auth.eu-south-2.amazoncognito.com',
  },
  [Stage.PROD]: {
    authority:
      'https://cognito-idp.eu-south-2.amazonaws.com/eu-south-2_RAkVKMEBj',
    client_id: 'rgc8mpc3o35q3tfn230mscj9o',
    redirect_uri: `https://${STAGE_HOSTNAMES[Stage.PROD][0]}`,
    response_type: 'code',
    scope: 'openid profile',
    logoutUri: 'https://adslots.in-adtech.amazon.dev/unauthorized-access',
    cognitoDomain: 'https://d1oi3giqqp2r8i.auth.eu-south-2.amazoncognito.com',
  },
};
export const unauthorizedRedirect = () => {
  const url: URL = new URL(window.location.href);
  const stage: Stage = parseStageFromUrl(url);
  const config = STAGE_AUTH_CONFIG[stage];

  if (!config) {
    throw new Error(`No auth configuration found for stage: ${stage}`);
  }

  const { client_id, logoutUri, cognitoDomain } = config;
  window.location.href = `${cognitoDomain}/logout?client_id=${client_id}&logout_uri=${encodeURIComponent(
    logoutUri
  )}`;
};

export function getCognitoAuthConfig(): AuthProviderProps {
  const url: URL = new URL(window.location.href);
  const stage: Stage = parseStageFromUrl(url);

  const config = STAGE_AUTH_CONFIG[stage];

  if (!config) {
    throw new Error(`No auth configuration found for stage: ${stage}`);
  }

  const redirect_uri =
    stage === Stage.DEV
      ? `http://${url.hostname}:${url.port}`
      : `https://${url.hostname}`;

  return {
    authority: config.authority,
    client_id: config.client_id,
    redirect_uri,
    response_type: 'code',
    scope: 'openid',
    automaticSilentRenew: true,
    onSigninCallback: (_user: any) => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };
}
